export default "__VITE_ASSET__arSflral__"